import { Head, Link, useForm, usePage } from '@inertiajs/react'
import { FormEvent, useState } from 'react'
import Alert from '../../components/Alert'
import PageHeader, { Wave } from '../../components/PageHeader'
import PhoneField from '../../components/PhoneField'
import TextField from '../../components/TextField'
import { Flash } from '../../types'

export default function Login() {
  const { props, url } = usePage<{ flash: Flash }>()
  const [tab, setTab] = useState<'email' | 'phone'>(url.includes('tab=phone') ? 'phone' : 'email')
  const emailForm = useForm({ email: '' })
  const phoneForm = useForm({ phone: '', ticket_number: '' })

  const submit = (e: FormEvent) => {
    e.preventDefault()
    if (tab === 'email') emailForm.post('/login')
    else phoneForm.post('/login/phone')
  }
  const processing = emailForm.processing || phoneForm.processing

  return (
    <>
      <Head title="Log in" />
      <main className="ho-screen">
        <PageHeader title="Welcome back!" subtitle="Log in to pick up your medal trail." />
        <form className="ho-form" onSubmit={submit}>
          <div className="ho-seg" role="group" aria-label="Log in with">
            <button type="button" aria-pressed={tab === 'email'} onClick={() => setTab('email')}>Email</button>
            <button type="button" aria-pressed={tab === 'phone'} onClick={() => setTab('phone')}>Phone number</button>
          </div>

          {props.flash?.alert && <Alert tone="error">{props.flash.alert}</Alert>}

          {tab === 'email' ? (
            <>
              <TextField
                label="Email Address"
                name="email"
                type="email"
                required
                autoComplete="email"
                placeholder="name@email.com"
                value={emailForm.data.email}
                onChange={(e) => emailForm.setData('email', e.target.value)}
                error={emailForm.errors.email}
              />
              <p className="ho-hint">Use the email you registered with. We’ll send you a 6‑digit code.</p>
            </>
          ) : (
            <>
              <PhoneField label="Phone Number" name="phone" required onChange={(v) => phoneForm.setData('phone', v)} />
              <TextField
                label="Ticket Number"
                name="ticket_number"
                required
                placeholder="Enter number on your ticket"
                value={phoneForm.data.ticket_number}
                onChange={(e) => phoneForm.setData('ticket_number', e.target.value)}
              />
              <p className="ho-hint">Use the phone number and ticket you registered with.</p>
            </>
          )}

          <button type="submit" className="ho-btn ho-btn-primary" disabled={processing}>
            {tab === 'email' ? (processing ? 'Sending…' : 'Send code') : processing ? 'Logging in…' : 'Log in'}
          </button>
          <p className="ho-foot">New here? <Link href="/register">Register for the event</Link></p>
        </form>
        <Wave />
      </main>
    </>
  )
}
